import api from './api';

export interface InstallmentRate {
  id: number;
  installments: number;
  rate: number;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface CreateInstallmentRateRequest {
  installments: number;
  rate: number;
  isActive?: boolean;
}

export const installmentRateService = {
  async getAll(): Promise<InstallmentRate[]> {
    const response = await api.get('/installment-rates');
    return response.data;
  },

  async create(data: CreateInstallmentRateRequest): Promise<InstallmentRate> {
    const response = await api.post('/installment-rates', data);
    return response.data;
  },

  async update(id: number, data: Partial<CreateInstallmentRateRequest>): Promise<InstallmentRate> {
    const response = await api.patch(`/installment-rates/${id}`, data);
    return response.data;
  },

  async delete(id: number): Promise<void> {
    await api.delete(`/installment-rates/${id}`);
  },
};
